import React from 'react';
import { StylovyzeDialog } from '@innovyze/stylovyze';
import { useGlobalization } from '@Translations/useGlobalization';

interface DeleteConfirmationDialogProps {
	open: boolean;
	title: string;
	children: React.ReactNode;
	onClose: () => void;
	onConfirm: () => void;
	isDeleting?: boolean;
}

export const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
	open,
	title,
	children,
	onClose,
	onConfirm,
	isDeleting = false,
}) => {
	const { t } = useGlobalization();

	return (
		<StylovyzeDialog
			open={open}
			title={title}
			cancelText={t('Cancel')}
			confirmText={isDeleting ? t('Deleting...') : t('Delete')}
			onCancel={() => {
				if (!isDeleting) onClose();
			}}
			onConfirm={() => {
				if (!isDeleting) onConfirm();
			}}
			confirmButtonProps={{ disabled: isDeleting }}
			dialogProps={{ fullWidth: true, maxWidth: 'sm' }}>
			{children}
		</StylovyzeDialog>
	);
};
